import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';

const useStyles = makeStyles()(() => ({
  label: {
    fontWeight: 'bold',
    fontSize: '12px',
    margin: '5px 0px',
  },
  root: {
    flex: '1',
  },
}));

export default function PrintableApplicationDetail(props) {
  const { classes } = useStyles();
  const { value = '' } = props;

  return (
    <div className={classes.root}>
      <div className={classes.label}>{props.label}</div>
      <Typography className={classes.value} variant="body2">
        {value}
      </Typography>
    </div>
  );
}

PrintableApplicationDetail.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};
